/**
 * 针对列表、报表的父类
 * 提供基本的分页查询功能
 */
export default {
    data() {
        return {
            listUrl: null,
            params: {
                mode: "MAIN",
                number: 1,
                size: 10
                // 其他一些请求相关静态参数都可以放在自定义params里面
            },
            items: []
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            let hq_keyword = to.query.hq_keyword || null, filterParam = to.query.filter || to.meta.filter
            if (hq_keyword) {
                vm.$refs.searchBar.keyword = hq_keyword
                vm.$refs.searchBar.$refs.input.value = hq_keyword
                vm.$refs.searchBar.focus()
            }
            let changed;
            // 传递筛选头初始化参数
            if (filterParam) {
                let filterParams = (typeof filterParam == 'string') ? JSON.parse(filterParam) : filterParam, 
                    filters = vm.$refs.filterBar.parsedFilters, filter
                Object.keys(filterParams).forEach(key => {
                    filter = filters.find(item => item.name == key || item.type == key)
                    if (filter) {
                        filter.value = filterParams[key]
                        changed = 1;
                        vm.$refs.filterBar.onChange(filter)
                    }
                })
            }
            if (!changed) {
                vm.onSearch();
            }
        });
    },
    computed: {
        /**
         * 用于取动态参数
         */
        extraParams() {
            return {};
        }
    },
    methods: {
        getCondition() {
            var me = this, filterBar = me.$refs.filterBar,
                filterCondition = filterBar ? filterBar.getCondition() : [],
                searchBar = me.$refs.searchBar,
                searchCondition = searchBar ? searchBar.getCondition() : null;
            if (searchCondition) {
                filterCondition.push(searchCondition);
            }
            if(me.otherCondition) {
                filterCondition.push(...me.otherCondition)
            }
            return filterCondition;
        },
        getMode() {
            var me = this, filterBar = me.$refs.filterBar, mode = me.params.mode;
            // 如果params.mode = 'DETAIL'，则始终使用DETAIL模式
            if (mode == 'MAIN' && filterBar) {
                return filterBar.getMode();
            }
            return mode;
        },
        /**
         * 查询
         * @param {*} callback 
         * @param {*} next 是否下一页
         */
         onSearch(callback, next) {
            var callbackFn = typeof callback === 'function' ? callback : null;
            this.doSearch(callbackFn, next);
         },
        /**
         * 查询（实际操作，onSearch可以被重写）
         * @param {*} callback 
         * @param {*} next 是否下一页
         */
        doSearch(callback, next) {
            var me = this,
                condition = me.getCondition(),
                params = Object.assign(
                    {
                        condition: JSON.stringify(condition)
                    },
                    me.params,
                    me.extraParams
                );
            params.number = (next && me.items.length) ? params.number + 1 : 1;
            params.mode = me.getMode();
            me.$loading({
                url: me.listUrl,
                params
            }).then(function (res) {
                callback && callback.call(me);
                if (res.success) {
                    var list
                    if(Array.isArray(res.data)) {
                        list = res.data;
                    } else {
                        list = res.data.list;
                    }
                    // 兼容报表界面返回参数
                    if (!Array.isArray(list) && list.list) {
                        list = list.list;
                    }
                    if (next) {
                        if (list.length) {
                            me.params.number = params.number;
                            me.items = me.items.concat(list);
                        }
                    } else {
                        me.params.number = 1;
                        me.items = list;
                    }
                } else {
                    me.$router.push({
                        name: "Error",
                        params: res
                    });
                }
            });
        },
        onSearchNext(callback) {
            this.onSearch(callback, 1);
        },
        /**
         * 合计
         * @param {*} prop 
         */
        getTotal(prop) {
            var total = 0,
                items = this.items;
            if (items) {
                items.forEach(item => {
                    total += item[prop] || 0;
                });
            }
            return total;
        },
    }
}